import { useFlags } from "launchdarkly-react-client-sdk";

import { AGENTS_CHAT_AGENT_TYPE } from "src/components/llm/amp-agent/use-agents-chat-runtime";
import {
  CHAT_SESSION_AGENT_TYPES,
  type ChatSessionAgentType,
} from "src/pages/agents/constants";

const WITH_AMP_AGENT_CHATS = [
  ...CHAT_SESSION_AGENT_TYPES,
  AGENTS_CHAT_AGENT_TYPE,
] as const;

/**
 * Returns the agent types of the user's chat list. AMP agent chats are listed
 * whenever piAgents is on, even when new chats use Claude.
 */
export function useChatSessionAgentTypes(): readonly ChatSessionAgentType[] {
  const { piAgents } = useFlags();
  return piAgents ? WITH_AMP_AGENT_CHATS : CHAT_SESSION_AGENT_TYPES;
}
